// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../hooks/useMergeProps';
import { selectEntitiesMatchesEntity } from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { MatchEntity } from '../../states/entities/matches';

import ScoreboardMultimatch from './ScoreboardMultimatch';

type ScoreboardMultimatchContainerProps = {
  className?: string;
  matchId: number;
};

const ScoreboardMultimatchContainer = (ownProps: ScoreboardMultimatchContainerProps) => {
  const match = useSelector((state) => selectEntitiesMatchesEntity(state, ownProps));
  const score = match?.score?.split(':');
  const isLive = MatchEntity.isLive(match);
  const isEnded = MatchEntity.isEnded(match);
  const outrightHasBegun = match?.isOutright && (isLive || isEnded);

  const selectedProps = useMemo(
    () => ({
      homeScore: score?.[0] ?? 0,
      awayScore: score?.[1] ?? 0,
      isEnded,
    }),
    [isEnded, score],
  );
  const enhancedProps = useMergeProps({ selectedProps, ownProps });

  if (!MatchEntity.isMultimatch(match) || !score || !outrightHasBegun) {
    return null;
  }

  return <ScoreboardMultimatch {...enhancedProps} />;
};

export default ScoreboardMultimatchContainer;
